var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShown)?_c('div',{staticClass:"emailBubble"},[_c('a',{attrs:{"href":_vm.emailLink,"target":"_blank"}},[_c('img',{staticClass:"fixed z-20 right-0 bottom-0 mb-20 mr-5",attrs:{"src":require("@/assets/email-btn.png")}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }